export const Offers = {
    offer_success: 'offer_success',
    offer_failure: 'offer_failure',
    offer_invalid: 'offer_invalid',
    offer_expired: 'offer_expired',
    offer_conflict: 'offer_conflict',
    offer_inapplicable: 'offer_inapplicable',
    best_discount_applied: 'best_discount_applied',
    offer_removed: 'offer_removed',
    samplesAndOffersLabel: 'samples_and_offers',
    congratulationsOffersLabel: 'congratulations_offer',
    qualifiedOffersLabel: 'qualified_offers_title',
    notQualifiedOffersLabel: 'not_qualified_offers_title',
    removeOfferLabel: 'remove_offer',
    applyOfferLabel: 'apply_offer',
    samplesLabel: 'samples',
    offersLabel: 'offers',
    sorryNoOffersAvailable: 'sorry_no_offers_available',
    excludedFromDiscounts: 'excluded_from_discounts',
    offerDeferred: 'offer_deferred',
    offerSampleOutOfStock: 'offer_sample_out_of_stock',
    offerRemovedSkuUnavailable: 'offer_removed_sku_unavailable',
    offerReplaced: 'offer_replaced',
    offerBenefitNotApplied: 'offer_benefit_not_applied',
    offerDeepDiscount: 'offer_deep_discount',

    // offers Carousel
    addingLabel: 'adding',
    removingLabel: 'removing',

    //offer Code Module
    failedToApplyOffer: 'failed_to_apply_offer',
    offerApplied: 'offer_applied'
};
